import React from 'react';
import PropTypes from 'prop-types';
import { Cushion, Rectangle, Space, Typography } from '@pitchero/react-ui';

const Form = ({ fixtures, style }) => (
  <Typography preset="name" color="white" component="div" style={style}>
    {fixtures.map((formFixture, i) => (
      <Rectangle
        key={formFixture.id}
        fill={`outcomeBg${formFixture.outcome}`}
        radius="100%"
        style={{ display: 'inline-block', textAlign: 'center', width: 15 }}
      >
        <Space left={i > 0 ? 'xsmall' : 0}>
          <Cushion all="xxsmall">{formFixture.outcome}</Cushion>
        </Space>
      </Rectangle>
    ))}
  </Typography>
);

Form.defaultProps = {
  style: {},
};

Form.propTypes = {
  fixtures: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      outcome: PropTypes.string.isRequired,
    }),
  ).isRequired,
  style: PropTypes.shape(),
};

export default Form;
